import i18n from "./index";

const locales = { en: "en-IN", hi: "hi-IN", kn: "kn-IN" };

export const getCurrentLocale = () => locales[i18n.resolvedLanguage] || locales.en;

